module.exports = {
	"job": {
		"lang": "en",
		"user_id": 46548,
		"name": "fit_traveler.mp3",
		"duration": 185,
		"created_at": "Fri Jul 27 20:11:38 2018",
		"id": 8856512
	},
	"speakers": [
		{
			"duration": "183.54",
			"confidence": null,
			"name": "M1",
			"time": "1.12"
		}
	],
	"words": [
		{
			"duration": "0.12",
			"confidence": "0.990",
			"name": "This",
			"time": "1.12"
		},
		{
			"duration": "0.12",
			"confidence": "0.980",
			"name": "is",
			"time": "1.24"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "episode",
			"time": "1.36"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "number",
			"time": "1.72"
		},
		{
			"duration": "0.75",
			"confidence": "0.860",
			"name": "27",
			"time": "2.01"
		},
		{
			"duration": "0.12",
			"confidence": "0.960",
			"name": "of",
			"time": "2.88"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "3.01"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "fit",
			"time": "3.10"
		},
		{
			"duration": "0.42",
			"confidence": "0.670",
			"name": "traveler",
			"time": "3.31"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "video",
			"time": "3.73"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "blog",
			"time": "4.09"
		},
		{
			"duration": "0.43",
			"confidence": "0.890",
			"name": ".",
			"time": "4.63"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "The",
			"time": "5.11"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "title",
			"time": "5.23"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "of",
			"time": "5.62"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "today's",
			"time": "5.74"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "session",
			"time": "6.01"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "is",
			"time": "6.40"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "probably",
			"time": "6.49"
		},
		{
			"duration": "0.15",
			"confidence": "0.990",
			"name": "going",
			"time": "6.73"
		},
		{
			"duration": "0.06",
			"confidence": "0.990",
			"name": "to",
			"time": "6.88"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "get",
			"time": "6.94"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "some",
			"time": "7.09"
		},
		{
			"duration": "0.30",
			"confidence": "0.990",
			"name": "people's",
			"time": "7.24"
		},
		{
			"duration": "0.66",
			"confidence": "1.000",
			"name": "attention",
			"time": "7.54"
		},
		{
			"duration": "0.29",
			"confidence": "0.980",
			"name": ".",
			"time": "8.20"
		},
		{
			"duration": "0.18",
			"confidence": "0.970",
			"name": "It's",
			"time": "8.50"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "called",
			"time": "8.68"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "Managing",
			"time": "8.92"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "the",
			"time": "9.55"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "bar",
			"time": "9.70"
		},
		{
			"duration": "0.29",
			"confidence": "0.960",
			"name": "scene",
			"time": "9.94"
		},
		{
			"duration": "0.04",
			"confidence": "0.910",
			"name": ".",
			"time": "10.42"
		},
		{
			"duration": "0.21",
			"confidence": "0.990",
			"name": "And",
			"time": "10.87"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "as",
			"time": "11.08"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "we",
			"time": "11.26"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "know",
			"time": "11.38"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "in",
			"time": "11.59"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "business",
			"time": "11.80"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "the",
			"time": "12.46"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "bar",
			"time": "12.61"
		},
		{
			"duration": "0.39",
			"confidence": "0.980",
			"name": "scene",
			"time": "12.88"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "comes",
			"time": "13.27"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "into",
			"time": "13.60"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "play",
			"time": "13.84"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "on",
			"time": "14.83"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "14.98"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "lot",
			"time": "15.04"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "of",
			"time": "15.19"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "different",
			"time": "15.31"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "occasions",
			"time": "15.58"
		},
		{
			"duration": "0.03",
			"confidence": "0.990",
			"name": ".",
			"time": "16.22"
		},
		{
			"duration": "0.20",
			"confidence": "0.980",
			"name": "So",
			"time": "16.31"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "first",
			"time": "16.51"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "let",
			"time": "17.05"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "me",
			"time": "17.20"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "tell",
			"time": "17.32"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "you",
			"time": "17.53"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "about",
			"time": "17.62"
		},
		{
			"duration": "0.17",
			"confidence": "0.750",
			"name": "what",
			"time": "17.98"
		},
		{
			"duration": "0.18",
			"confidence": "0.960",
			"name": "we're",
			"time": "18.16"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "not",
			"time": "18.34"
		},
		{
			"duration": "0.12",
			"confidence": "0.990",
			"name": "going",
			"time": "18.85"
		},
		{
			"duration": "0.09",
			"confidence": "0.990",
			"name": "to",
			"time": "18.97"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "be",
			"time": "19.06"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "addressing",
			"time": "19.18"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "in",
			"time": "20.23"
		},
		{
			"duration": "0.09",
			"confidence": "0.910",
			"name": "this",
			"time": "20.41"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "session",
			"time": "20.50"
		},
		{
			"duration": "0.20",
			"confidence": "0.940",
			"name": ".",
			"time": "21.04"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "Go",
			"time": "21.25"
		},
		{
			"duration": "0.18",
			"confidence": "0.970",
			"name": "ahead",
			"time": "21.43"
		},
		{
			"duration": "0.06",
			"confidence": "0.830",
			"name": ".",
			"time": "21.61"
		},
		{
			"duration": "0.24",
			"confidence": "0.980",
			"name": "Set",
			"time": "21.67"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "21.91"
		},
		{
			"duration": "0.60",
			"confidence": "0.770",
			"name": "expectations",
			"time": "22.00"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "for",
			"time": "22.60"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "you",
			"time": "22.84"
		},
		{
			"duration": "0.35",
			"confidence": "0.900",
			"name": ".",
			"time": "23.05"
		},
		{
			"duration": "0.09",
			"confidence": "0.970",
			"name": "We're",
			"time": "23.44"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "not",
			"time": "23.53"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "talking",
			"time": "23.71"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "about",
			"time": "23.98"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "whether",
			"time": "24.25"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "you",
			"time": "24.55"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "should",
			"time": "24.70"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "or",
			"time": "25.09"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "should",
			"time": "25.24"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "not",
			"time": "25.48"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "drink",
			"time": "25.72"
		},
		{
			"duration": "0.22",
			"confidence": "0.940",
			"name": "that",
			"time": "26.71"
		},
		{
			"duration": "0.11",
			"confidence": "0.520",
			"name": ".",
			"time": "26.97"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "That's",
			"time": "27.19"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "your",
			"time": "27.40"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "business",
			"time": "27.55"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "not",
			"time": "27.97"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "mine",
			"time": "28.21"
		},
		{
			"duration": "0.34",
			"confidence": "0.940",
			"name": ".",
			"time": "28.66"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "We're",
			"time": "29.02"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "also",
			"time": "29.17"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "not",
			"time": "29.50"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "talking",
			"time": "29.80"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "about",
			"time": "30.25"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "if",
			"time": "30.70"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "you",
			"time": "30.88"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "have",
			"time": "31.00"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "31.12"
		},
		{
			"duration": "0.21",
			"confidence": "0.920",
			"name": "fit",
			"time": "31.18"
		},
		{
			"duration": "0.66",
			"confidence": "1.000",
			"name": "lifestyle",
			"time": "31.39"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "but",
			"time": "32.08"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "you",
			"time": "32.23"
		},
		{
			"duration": "0.15",
			"confidence": "0.990",
			"name": "like",
			"time": "32.35"
		},
		{
			"duration": "0.12",
			"confidence": "0.990",
			"name": "to",
			"time": "32.50"
		},
		{
			"duration": "0.18",
			"confidence": "0.990",
			"name": "go",
			"time": "32.62"
		},
		{
			"duration": "0.12",
			"confidence": "0.980",
			"name": "out",
			"time": "32.80"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "on",
			"time": "32.92"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "33.01"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "weekends",
			"time": "33.10"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "and",
			"time": "34.61"
		},
		{
			"duration": "0.57",
			"confidence": "0.980",
			"name": "participate",
			"time": "34.90"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "in",
			"time": "35.47"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "35.56"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "bar",
			"time": "35.65"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "scene",
			"time": "35.86"
		},
		{
			"duration": "0.55",
			"confidence": "0.960",
			"name": ".",
			"time": "36.31"
		},
		{
			"duration": "0.21",
			"confidence": "0.990",
			"name": "We're",
			"time": "36.88"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "not",
			"time": "37.09"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "addressing",
			"time": "37.51"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "that",
			"time": "37.96"
		},
		{
			"duration": "0.31",
			"confidence": "0.940",
			"name": "today",
			"time": "38.14"
		},
		{
			"duration": "0.04",
			"confidence": "0.750",
			"name": ".",
			"time": "38.45"
		},
		{
			"duration": "0.18",
			"confidence": "0.990",
			"name": "I'm",
			"time": "38.50"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "the",
			"time": "38.68"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "last",
			"time": "38.80"
		},
		{
			"duration": "0.29",
			"confidence": "1.000",
			"name": "person",
			"time": "39.13"
		},
		{
			"duration": "0.12",
			"confidence": "0.460",
			"name": "there",
			"time": "39.42"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "should",
			"time": "39.55"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "be",
			"time": "39.73"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "talking",
			"time": "39.82"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "about",
			"time": "40.21"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "that",
			"time": "40.39"
		},
		{
			"duration": "0.03",
			"confidence": "0.930",
			"name": ".",
			"time": "40.60"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "It's",
			"time": "40.63"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "been",
			"time": "40.75"
		},
		{
			"duration": "0.08",
			"confidence": "1.000",
			"name": "a",
			"time": "41.47"
		},
		{
			"duration": "0.19",
			"confidence": "0.680",
			"name": "while",
			"time": "41.55"
		},
		{
			"duration": "0.10",
			"confidence": "0.680",
			"name": "I'm",
			"time": "41.79"
		},
		{
			"duration": "0.41",
			"confidence": "0.670",
			"name": "along",
			"time": "41.89"
		},
		{
			"duration": "0.07",
			"confidence": "0.750",
			"name": "a",
			"time": "42.30"
		},
		{
			"duration": "0.20",
			"confidence": "0.740",
			"name": "lot",
			"time": "42.38"
		},
		{
			"duration": "0.11",
			"confidence": "1.000",
			"name": "a",
			"time": "42.58"
		},
		{
			"duration": "0.22",
			"confidence": "1.000",
			"name": "lot",
			"time": "42.69"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "of",
			"time": "42.91"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "years",
			"time": "42.97"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "removed",
			"time": "43.27"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "from",
			"time": "43.81"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "that",
			"time": "44.02"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "scene",
			"time": "44.20"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "so",
			"time": "44.53"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "44.89"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "wouldn't",
			"time": "44.98"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "be",
			"time": "45.19"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "I",
			"time": "45.85"
		},
		{
			"duration": "0.17",
			"confidence": "0.520",
			"name": "wouldn't",
			"time": "45.91"
		},
		{
			"duration": "0.16",
			"confidence": "1.000",
			"name": "do",
			"time": "46.08"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "any",
			"time": "46.24"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "good",
			"time": "46.42"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "to",
			"time": "46.63"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "speak",
			"time": "46.78"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "to",
			"time": "47.02"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "you",
			"time": "47.08"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "about",
			"time": "47.20"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "that",
			"time": "47.41"
		},
		{
			"duration": "0.22",
			"confidence": "0.890",
			"name": ".",
			"time": "47.68"
		},
		{
			"duration": "0.13",
			"confidence": "0.530",
			"name": "What",
			"time": "48.03"
		},
		{
			"duration": "0.14",
			"confidence": "1.000",
			"name": "we're",
			"time": "48.17"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "talking",
			"time": "48.31"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "about",
			"time": "48.67"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "is",
			"time": "49.03"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "in",
			"time": "49.18"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "the",
			"time": "49.30"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "business",
			"time": "49.42"
		},
		{
			"duration": "0.59",
			"confidence": "1.000",
			"name": "setting",
			"time": "49.90"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "as",
			"time": "50.50"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "business",
			"time": "50.71"
		},
		{
			"duration": "0.81",
			"confidence": "1.000",
			"name": "professionals",
			"time": "51.07"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "how",
			"time": "52.21"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "you",
			"time": "52.45"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "manage",
			"time": "52.63"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "that",
			"time": "53.02"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "bar",
			"time": "53.26"
		},
		{
			"duration": "0.54",
			"confidence": "0.840",
			"name": "scene",
			"time": "53.53"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "that",
			"time": "54.43"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "comes",
			"time": "54.67"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "up",
			"time": "55.03"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "in",
			"time": "55.30"
		},
		{
			"duration": "0.80",
			"confidence": "0.920",
			"name": "events",
			"time": "56.09"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "pretty",
			"time": "57.19"
		},
		{
			"duration": "0.47",
			"confidence": "0.880",
			"name": "often",
			"time": "57.55"
		},
		{
			"duration": "0.03",
			"confidence": "0.590",
			"name": ".",
			"time": "58.03"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "If",
			"time": "58.09"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "you're",
			"time": "58.27"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "in",
			"time": "58.45"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "any",
			"time": "58.66"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "kind",
			"time": "58.96"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "of",
			"time": "59.14"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "business",
			"time": "59.23"
		},
		{
			"duration": "0.24",
			"confidence": "0.710",
			"name": "you",
			"time": "60.64"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "likely",
			"time": "60.88"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "come",
			"time": "61.30"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "across",
			"time": "61.54"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "some",
			"time": "62.26"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "sort",
			"time": "62.50"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "of",
			"time": "62.71"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "bar",
			"time": "62.86"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "scene",
			"time": "63.19"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "event",
			"time": "63.61"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "maybe",
			"time": "64.54"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "once",
			"time": "64.78"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "or",
			"time": "64.99"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "twice",
			"time": "65.08"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "65.35"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "month",
			"time": "65.41"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "maybe",
			"time": "66.79"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "less",
			"time": "67.12"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "frequent",
			"time": "67.36"
		},
		{
			"duration": "0.17",
			"confidence": "0.950",
			"name": "just",
			"time": "67.75"
		},
		{
			"duration": "0.24",
			"confidence": "0.410",
			"name": "spinning",
			"time": "67.95"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "on",
			"time": "68.20"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "your",
			"time": "68.32"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "type",
			"time": "68.44"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "of",
			"time": "68.98"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "business",
			"time": "69.10"
		},
		{
			"duration": "0.27",
			"confidence": "0.690",
			"name": ".",
			"time": "69.64"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "If",
			"time": "70.03"
		},
		{
			"duration": "0.18",
			"confidence": "0.930",
			"name": "you",
			"time": "70.21"
		},
		{
			"duration": "0.12",
			"confidence": "0.930",
			"name": "are",
			"time": "70.39"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "70.51"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "business",
			"time": "70.57"
		},
		{
			"duration": "0.72",
			"confidence": "0.580",
			"name": "traveler",
			"time": "71.02"
		},
		{
			"duration": "0.18",
			"confidence": "0.990",
			"name": "you",
			"time": "72.07"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "probably",
			"time": "72.25"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "come",
			"time": "72.79"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "across",
			"time": "73.00"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "this",
			"time": "73.42"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "multiple",
			"time": "73.75"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "times",
			"time": "74.11"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "each",
			"time": "74.50"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "week",
			"time": "74.74"
		},
		{
			"duration": "0.03",
			"confidence": "0.910",
			"name": ".",
			"time": "75.22"
		},
		{
			"duration": "0.18",
			"confidence": "0.900",
			"name": "It's",
			"time": "75.25"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "just",
			"time": "75.43"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "kind",
			"time": "75.61"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "of",
			"time": "75.76"
		},
		{
			"duration": "0.06",
			"confidence": "0.550",
			"name": "a",
			"time": "75.85"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "nature",
			"time": "75.91"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "of",
			"time": "76.27"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "76.39"
		},
		{
			"duration": "0.50",
			"confidence": "1.000",
			"name": "beast",
			"time": "76.48"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "you",
			"time": "77.41"
		},
		{
			"duration": "1.02",
			"confidence": "1.000",
			"name": "are",
			"time": "77.74"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "going",
			"time": "78.94"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "to",
			"time": "79.33"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "a",
			"time": "79.87"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "business",
			"time": "80.35"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "meeting",
			"time": "80.80"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "or",
			"time": "81.19"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "maybe",
			"time": "81.37"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "after",
			"time": "81.67"
		},
		{
			"duration": "0.03",
			"confidence": "1.000",
			"name": "a",
			"time": "81.97"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "business",
			"time": "82.00"
		},
		{
			"duration": "0.31",
			"confidence": "1.000",
			"name": "meeting",
			"time": "82.36"
		},
		{
			"duration": "0.15",
			"confidence": "0.430",
			"name": "you're",
			"time": "82.71"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "going",
			"time": "82.90"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "to",
			"time": "83.02"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "have",
			"time": "83.08"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "dinner",
			"time": "83.23"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "and",
			"time": "84.16"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "it's",
			"time": "84.43"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "very",
			"time": "84.61"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "common",
			"time": "84.94"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "for",
			"time": "85.39"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "them",
			"time": "85.57"
		},
		{
			"duration": "0.55",
			"confidence": "0.990",
			"name": "for",
			"time": "85.91"
		},
		{
			"duration": "0.18",
			"confidence": "0.720",
			"name": "there",
			"time": "86.52"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "just",
			"time": "86.71"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "to",
			"time": "86.89"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "be",
			"time": "86.98"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "an",
			"time": "87.10"
		},
		{
			"duration": "0.62",
			"confidence": "1.000",
			"name": "invitation",
			"time": "87.19"
		},
		{
			"duration": "0.17",
			"confidence": "0.680",
			"name": "of",
			"time": "87.88"
		},
		{
			"duration": "0.18",
			"confidence": "0.990",
			"name": "hey",
			"time": "88.33"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "we're",
			"time": "88.51"
		},
		{
			"duration": "0.10",
			"confidence": "0.870",
			"name": "going",
			"time": "88.63"
		},
		{
			"duration": "0.08",
			"confidence": "0.870",
			"name": "to",
			"time": "88.73"
		},
		{
			"duration": "0.12",
			"confidence": "0.930",
			"name": "be",
			"time": "88.81"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "down",
			"time": "88.93"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "at",
			"time": "89.18"
		},
		{
			"duration": "0.12",
			"confidence": "0.990",
			"name": "the",
			"time": "90.22"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "bar",
			"time": "90.34"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "before",
			"time": "90.88"
		},
		{
			"duration": "0.32",
			"confidence": "1.000",
			"name": "dinner",
			"time": "91.27"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "to",
			"time": "91.63"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "grab",
			"time": "91.78"
		},
		{
			"duration": "0.03",
			"confidence": "1.000",
			"name": "a",
			"time": "92.02"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "drink",
			"time": "92.05"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "then",
			"time": "93.01"
		},
		{
			"duration": "0.21",
			"confidence": "0.990",
			"name": "you're",
			"time": "93.34"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "at",
			"time": "93.55"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "dinner",
			"time": "93.79"
		},
		{
			"duration": "0.17",
			"confidence": "0.930",
			"name": "and",
			"time": "94.24"
		},
		{
			"duration": "0.15",
			"confidence": "0.690",
			"name": "there",
			"time": "94.41"
		},
		{
			"duration": "0.08",
			"confidence": "0.680",
			"name": "is",
			"time": "94.55"
		},
		{
			"duration": "0.06",
			"confidence": "0.870",
			"name": "a",
			"time": "94.63"
		},
		{
			"duration": "0.38",
			"confidence": "0.850",
			"name": "line",
			"time": "94.70"
		},
		{
			"duration": "0.09",
			"confidence": "0.930",
			"name": "in",
			"time": "95.08"
		},
		{
			"duration": "0.15",
			"confidence": "0.980",
			"name": "their",
			"time": "95.17"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "drinks",
			"time": "95.32"
		},
		{
			"duration": "0.09",
			"confidence": "0.870",
			"name": "and",
			"time": "95.71"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "whatever",
			"time": "95.80"
		},
		{
			"duration": "0.36",
			"confidence": "0.780",
			"name": ".",
			"time": "96.31"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "And",
			"time": "96.67"
		},
		{
			"duration": "0.21",
			"confidence": "0.990",
			"name": "then",
			"time": "96.82"
		},
		{
			"duration": "0.45",
			"confidence": "0.870",
			"name": "there's",
			"time": "97.06"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "after",
			"time": "97.60"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "dinner",
			"time": "98.32"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "there's",
			"time": "98.71"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "the",
			"time": "98.95"
		},
		{
			"duration": "0.46",
			"confidence": "0.880",
			"name": "nightcap",
			"time": "99.07"
		},
		{
			"duration": "0.08",
			"confidence": "0.640",
			"name": ".",
			"time": "99.53"
		},
		{
			"duration": "0.18",
			"confidence": "0.960",
			"name": "Let's",
			"time": "99.64"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "go",
			"time": "99.82"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "back",
			"time": "99.94"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "to",
			"time": "100.09"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "100.18"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "bar",
			"time": "100.27"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "for",
			"time": "100.45"
		},
		{
			"duration": "0.03",
			"confidence": "1.000",
			"name": "a",
			"time": "100.60"
		},
		{
			"duration": "0.49",
			"confidence": "1.000",
			"name": "nightcap",
			"time": "100.63"
		},
		{
			"duration": "0.02",
			"confidence": "0.690",
			"name": ".",
			"time": "101.12"
		},
		{
			"duration": "0.20",
			"confidence": "0.930",
			"name": "Okay",
			"time": "101.17"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "so",
			"time": "101.38"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "these",
			"time": "101.56"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "events",
			"time": "101.92"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "are",
			"time": "103.00"
		},
		{
			"duration": "0.84",
			"confidence": "1.000",
			"name": "regular",
			"time": "103.21"
		},
		{
			"duration": "0.90",
			"confidence": "1.000",
			"name": "occurrences",
			"time": "104.05"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "for",
			"time": "105.04"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "business",
			"time": "105.22"
		},
		{
			"duration": "0.57",
			"confidence": "0.880",
			"name": "travelers",
			"time": "105.58"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "and",
			"time": "106.15"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "business",
			"time": "106.30"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "professionals",
			"time": "106.63"
		},
		{
			"duration": "0.12",
			"confidence": "0.980",
			"name": "in",
			"time": "107.23"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "general",
			"time": "107.35"
		},
		{
			"duration": "0.59",
			"confidence": "0.890",
			"name": ".",
			"time": "107.87"
		},
		{
			"duration": "0.26",
			"confidence": "0.620",
			"name": "At",
			"time": "108.61"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "109.00"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "lot",
			"time": "109.06"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "of",
			"time": "109.24"
		},
		{
			"duration": "0.87",
			"confidence": "1.000",
			"name": "companies",
			"time": "109.36"
		},
		{
			"duration": "0.15",
			"confidence": "0.990",
			"name": "will",
			"time": "110.50"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "do",
			"time": "110.65"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "some",
			"time": "110.86"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "sort",
			"time": "111.10"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "of",
			"time": "111.31"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "company",
			"time": "111.43"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "happy",
			"time": "111.79"
		},
		{
			"duration": "0.33",
			"confidence": "0.990",
			"name": "hour",
			"time": "112.15"
		},
		{
			"duration": "0.36",
			"confidence": "0.530",
			"name": "whether",
			"time": "112.48"
		},
		{
			"duration": "0.17",
			"confidence": "0.420",
			"name": "they're",
			"time": "112.91"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "putting",
			"time": "113.14"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "it",
			"time": "113.44"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "on",
			"time": "113.53"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "or",
			"time": "113.92"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "one",
			"time": "114.07"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "of",
			"time": "114.25"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "their",
			"time": "114.34"
		},
		{
			"duration": "0.38",
			"confidence": "0.880",
			"name": "vendors",
			"time": "114.49"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "putting",
			"time": "114.88"
		},
		{
			"duration": "0.12",
			"confidence": "0.500",
			"name": "it",
			"time": "115.15"
		},
		{
			"duration": "0.30",
			"confidence": "0.950",
			"name": "on",
			"time": "115.27"
		},
		{
			"duration": "0.09",
			"confidence": "0.970",
			"name": "or",
			"time": "115.57"
		},
		{
			"duration": "0.09",
			"confidence": "0.940",
			"name": "a",
			"time": "115.66"
		},
		{
			"duration": "0.36",
			"confidence": "0.980",
			"name": "client",
			"time": "115.75"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "putting",
			"time": "116.11"
		},
		{
			"duration": "0.26",
			"confidence": "1.000",
			"name": "on",
			"time": "116.39"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "or",
			"time": "116.65"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "whatever",
			"time": "116.74"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "it",
			"time": "117.04"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "may",
			"time": "117.13"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "be",
			"time": "117.28"
		},
		{
			"duration": "0.39",
			"confidence": "0.930",
			"name": ".",
			"time": "117.55"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "So",
			"time": "117.97"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "that's",
			"time": "118.18"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "what",
			"time": "118.48"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "we're",
			"time": "118.63"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "talking",
			"time": "118.75"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "about",
			"time": "119.11"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "today",
			"time": "119.29"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "is",
			"time": "119.83"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "as",
			"time": "120.22"
		},
		{
			"duration": "0.09",
			"confidence": "0.950",
			"name": "a",
			"time": "120.67"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "business",
			"time": "120.76"
		},
		{
			"duration": "0.78",
			"confidence": "1.000",
			"name": "professional",
			"time": "121.15"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "who",
			"time": "122.35"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "has",
			"time": "122.53"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "a",
			"time": "123.01"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "fit",
			"time": "123.16"
		},
		{
			"duration": "0.66",
			"confidence": "1.000",
			"name": "lifestyle",
			"time": "123.49"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "or",
			"time": "124.18"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "is",
			"time": "124.39"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "adopting",
			"time": "124.54"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "a",
			"time": "125.17"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "new",
			"time": "125.29"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "healthy",
			"time": "125.50"
		},
		{
			"duration": "0.75",
			"confidence": "1.000",
			"name": "lifestyle",
			"time": "125.80"
		},
		{
			"duration": "0.27",
			"confidence": "0.990",
			"name": ".",
			"time": "126.55"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "How",
			"time": "126.82"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "do",
			"time": "126.94"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "you",
			"time": "127.00"
		},
		{
			"duration": "0.72",
			"confidence": "1.000",
			"name": "manage",
			"time": "127.15"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "127.96"
		},
		{
			"duration": "0.23",
			"confidence": "0.920",
			"name": "bar",
			"time": "128.05"
		},
		{
			"duration": "0.47",
			"confidence": "0.470",
			"name": "scenes",
			"time": "128.30"
		},
		{
			"duration": "0.18",
			"confidence": "0.510",
			"name": "OK",
			"time": "128.82"
		},
		{
			"duration": "0.14",
			"confidence": "0.690",
			"name": ".",
			"time": "129.13"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "So",
			"time": "129.58"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "I'm",
			"time": "129.85"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "going",
			"time": "130.06"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "to",
			"time": "130.33"
		},
		{
			"duration": "0.81",
			"confidence": "1.000",
			"name": "assume",
			"time": "130.51"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "for",
			"time": "131.35"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "the",
			"time": "131.50"
		},
		{
			"duration": "0.78",
			"confidence": "1.000",
			"name": "purposes",
			"time": "131.62"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "of",
			"time": "132.40"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "this",
			"time": "132.58"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "session",
			"time": "133.15"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "I'm",
			"time": "133.78"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "going",
			"time": "133.96"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "to",
			"time": "134.23"
		},
		{
			"duration": "0.84",
			"confidence": "1.000",
			"name": "assume",
			"time": "134.38"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "that",
			"time": "135.64"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "you've",
			"time": "135.85"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "chosen",
			"time": "136.03"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "to",
			"time": "136.57"
		},
		{
			"duration": "0.87",
			"confidence": "1.000",
			"name": "participate",
			"time": "136.78"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "in",
			"time": "137.71"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "137.80"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "bar",
			"time": "137.89"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "scene",
			"time": "138.07"
		},
		{
			"duration": "0.02",
			"confidence": "0.830",
			"name": ".",
			"time": "138.31"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "So",
			"time": "138.34"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "when",
			"time": "138.52"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "somebody",
			"time": "138.67"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "says",
			"time": "139.00"
		},
		{
			"duration": "0.09",
			"confidence": "0.980",
			"name": "we're",
			"time": "139.87"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "going",
			"time": "139.96"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "to",
			"time": "140.08"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "go",
			"time": "140.14"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "meet",
			"time": "140.35"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "for",
			"time": "140.53"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "a",
			"time": "140.68"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "drink",
			"time": "140.77"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "you",
			"time": "141.31"
		},
		{
			"duration": "0.12",
			"confidence": "0.890",
			"name": "are",
			"time": "141.55"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "actually",
			"time": "141.67"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "going",
			"time": "141.91"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "to",
			"time": "142.03"
		},
		{
			"duration": "0.38",
			"confidence": "1.000",
			"name": "go",
			"time": "142.12"
		},
		{
			"duration": "0.09",
			"confidence": "0.740",
			"name": "and",
			"time": "142.50"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "participate",
			"time": "142.63"
		},
		{
			"duration": "0.25",
			"confidence": "0.610",
			"name": "OK",
			"time": "143.51"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "maybe",
			"time": "144.01"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "you",
			"time": "144.37"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "have",
			"time": "144.67"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "chosen",
			"time": "144.88"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "not",
			"time": "145.33"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "145.54"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "go",
			"time": "145.66"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "or",
			"time": "146.32"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "to",
			"time": "146.50"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "go",
			"time": "146.65"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "and",
			"time": "146.95"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "not",
			"time": "147.16"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "147.37"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "drink",
			"time": "147.49"
		},
		{
			"duration": "0.03",
			"confidence": "0.630",
			"name": ".",
			"time": "147.88"
		},
		{
			"duration": "0.11",
			"confidence": "0.940",
			"name": "And",
			"time": "147.92"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "that's",
			"time": "148.03"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "all",
			"time": "148.27"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "good",
			"time": "148.54"
		},
		{
			"duration": "0.26",
			"confidence": "0.670",
			"name": ".",
			"time": "149.02"
		},
		{
			"duration": "0.12",
			"confidence": "0.980",
			"name": "We're",
			"time": "149.41"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "talking",
			"time": "149.53"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "about",
			"time": "149.83"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "150.04"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "times",
			"time": "150.13"
		},
		{
			"duration": "0.18",
			"confidence": "0.980",
			"name": "when",
			"time": "150.52"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "you",
			"time": "150.70"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "have",
			"time": "150.91"
		},
		{
			"duration": "0.42",
			"confidence": "0.990",
			"name": "gone",
			"time": "151.15"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "when",
			"time": "151.63"
		},
		{
			"duration": "0.11",
			"confidence": "0.810",
			"name": "you're",
			"time": "151.84"
		},
		{
			"duration": "0.11",
			"confidence": "0.900",
			"name": "going",
			"time": "151.96"
		},
		{
			"duration": "0.10",
			"confidence": "0.900",
			"name": "to",
			"time": "152.07"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "go",
			"time": "152.17"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "and",
			"time": "152.53"
		},
		{
			"duration": "0.12",
			"confidence": "0.920",
			"name": "you're",
			"time": "152.68"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "going",
			"time": "152.80"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "to",
			"time": "152.92"
		},
		{
			"duration": "0.66",
			"confidence": "1.000",
			"name": "participate",
			"time": "153.01"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "in",
			"time": "153.67"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "the",
			"time": "154.00"
		},
		{
			"duration": "0.12",
			"confidence": "0.690",
			"name": "bar",
			"time": "154.12"
		},
		{
			"duration": "0.32",
			"confidence": "0.690",
			"name": "scene",
			"time": "154.24"
		},
		{
			"duration": "0.03",
			"confidence": "0.940",
			"name": ".",
			"time": "154.57"
		},
		{
			"duration": "0.22",
			"confidence": "0.900",
			"name": "OK",
			"time": "154.65"
		},
		{
			"duration": "0.33",
			"confidence": "0.710",
			"name": ".",
			"time": "155.03"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "So",
			"time": "155.38"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "that",
			"time": "155.77"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "kind",
			"time": "156.13"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "of",
			"time": "156.31"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "set",
			"time": "156.40"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "some",
			"time": "156.70"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "context",
			"time": "156.91"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "for",
			"time": "157.98"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "where",
			"time": "158.17"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "we",
			"time": "158.35"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "are",
			"time": "158.56"
		},
		{
			"duration": "0.28",
			"confidence": "0.860",
			"name": "now",
			"time": "159.35"
		},
		{
			"duration": "0.06",
			"confidence": "0.760",
			"name": ".",
			"time": "159.64"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "Let's",
			"time": "159.70"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "paint",
			"time": "161.02"
		},
		{
			"duration": "0.06",
			"confidence": "0.730",
			"name": "the",
			"time": "161.26"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "picture",
			"time": "161.32"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "that",
			"time": "161.71"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "you",
			"time": "161.92"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "have",
			"time": "162.16"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "this",
			"time": "162.46"
		},
		{
			"duration": "0.33",
			"confidence": "0.990",
			"name": "fit",
			"time": "163.15"
		},
		{
			"duration": "0.72",
			"confidence": "1.000",
			"name": "lifestyle",
			"time": "163.48"
		},
		{
			"duration": "0.14",
			"confidence": "0.730",
			"name": "and",
			"time": "164.22"
		},
		{
			"duration": "0.22",
			"confidence": "1.000",
			"name": "it's",
			"time": "164.37"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "already",
			"time": "164.59"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "been",
			"time": "164.83"
		},
		{
			"duration": "0.15",
			"confidence": "0.990",
			"name": "in",
			"time": "165.01"
		},
		{
			"duration": "0.86",
			"confidence": "1.000",
			"name": "existence",
			"time": "165.16"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "and",
			"time": "166.27"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "you",
			"time": "166.60"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "are",
			"time": "166.87"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "eating",
			"time": "167.20"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "healthy",
			"time": "167.50"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "and",
			"time": "167.98"
		},
		{
			"duration": "0.12",
			"confidence": "0.860",
			"name": "you",
			"time": "168.10"
		},
		{
			"duration": "0.18",
			"confidence": "0.700",
			"name": "get",
			"time": "168.22"
		},
		{
			"duration": "0.06",
			"confidence": "0.990",
			"name": "a",
			"time": "168.40"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "good",
			"time": "168.46"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "exercise",
			"time": "168.73"
		},
		{
			"duration": "0.65",
			"confidence": "1.000",
			"name": "routine",
			"time": "169.24"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "but",
			"time": "170.23"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "you",
			"time": "170.35"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "just",
			"time": "170.50"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "can't",
			"time": "170.77"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "figure",
			"time": "171.04"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "out",
			"time": "171.34"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "how",
			"time": "171.46"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "to",
			"time": "171.58"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "manage",
			"time": "171.85"
		},
		{
			"duration": "0.23",
			"confidence": "0.910",
			"name": "this",
			"time": "172.27"
		},
		{
			"duration": "0.17",
			"confidence": "0.710",
			"name": "bar",
			"time": "172.51"
		},
		{
			"duration": "0.34",
			"confidence": "0.680",
			"name": "scene",
			"time": "172.68"
		},
		{
			"duration": "0.72",
			"confidence": "0.990",
			"name": "correctly",
			"time": "173.02"
		},
		{
			"duration": "0.54",
			"confidence": "0.930",
			"name": ".",
			"time": "173.74"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "Maybe",
			"time": "174.28"
		},
		{
			"duration": "0.12",
			"confidence": "0.960",
			"name": "we've",
			"time": "174.55"
		},
		{
			"duration": "0.15",
			"confidence": "0.980",
			"name": "got",
			"time": "174.67"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "some",
			"time": "174.82"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "tips",
			"time": "174.97"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "for",
			"time": "175.24"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "you",
			"time": "175.42"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "or",
			"time": "175.81"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "you",
			"time": "176.74"
		},
		{
			"duration": "0.30",
			"confidence": "0.520",
			"name": "haven't",
			"time": "176.89"
		},
		{
			"duration": "0.14",
			"confidence": "0.700",
			"name": "been",
			"time": "177.19"
		},
		{
			"duration": "0.13",
			"confidence": "0.970",
			"name": "on",
			"time": "177.39"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "track",
			"time": "177.52"
		},
		{
			"duration": "0.28",
			"confidence": "0.910",
			"name": ".",
			"time": "178.06"
		},
		{
			"duration": "0.17",
			"confidence": "0.910",
			"name": "You're",
			"time": "178.36"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "trying",
			"time": "178.54"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "to",
			"time": "178.96"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "adopt",
			"time": "179.29"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "new",
			"time": "179.89"
		},
		{
			"duration": "0.84",
			"confidence": "1.000",
			"name": "lifestyle",
			"time": "180.49"
		}
	],
	"format": "1.0"
};


//////////////////
// WEBPACK FOOTER
// ./src/fit_traveler.json
// module id = 26
// module chunks = 0